<template>
    <div >

        <el-form :model="ruleFormPwd" ref="ruleFormPwd" style="width: 400px;margin: 0 auto;">
            <el-form-item >
                <el-button type="text" @click="preStep">
                    <span>< {{distinguishNorZh}}</span>
                </el-button>
            </el-form-item>
            <el-form-item  prop="pwd1"  :rules="{required: true, message: '密码不能为空', trigger: 'blur'}" label="设置密码" label-width="80px">
                <el-input style="height: 50px; width: 320px;" v-model="ruleFormPwd.pwd1" class="numberInput" placeholder="设置密码"></el-input>
            </el-form-item>
            <el-form-item  label="确认密码" prop="pwd2" :rules="{required: true, message: '密码不能为空', trigger: 'blur'}" label-width="80px">
                <el-input style="height: 50px; width: 320px;" v-model="ruleFormPwd.pwd2" class="numberInput" placeholder="确认密码"></el-input>
                <div class="numberColor text-s-size">
                    *密码必须同时包含数字与字母，6-16位，注意字母大小写
                </div>
            </el-form-item>

            <el-form-item >
                <el-button   style="width: 100%;height: 50px;" @click="nextStep()" type="primary">确认注册</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {verificationPwd} from "../../../../config";
    import {setSessionStore, setStore} from "../../../../assets/static/global/global";
    import cookies from 'js-cookie'
    export default {
        name: "registerSecond",
        props:{
            distinguishNorZh:String
        },
        data(){
            return{
                ruleFormPwd:{
                    pwd1:'',
                    pwd2:''
                }
            }
        },
        methods:{
            nextStep(val){
                this.$refs['ruleFormPwd'].validate(async (valid)=>{
                    if(valid){
                        let type='';
                        let userName='';
                        let phone='';
                        let zhi=String(this.distinguishNorZh).substr(String(this.distinguishNorZh).indexOf(':')+1);
                        console.log('我是获取到的手机号或账号');
                        console.log(zhi);
                        /*判断是用用户名方式的验证密码还是手机号方式的验证密码*/
                        if(String(this.distinguishNorZh).indexOf('账号')!==-1){
                            type=2;
                            userName=zhi;
                            phone='';
                        }else{
                            userName='';
                            phone=zhi;
                            type=1;
                        }
                        console.log('是获取到的类型');
                        console.log(type);
                        /*参数分别是需要验证的密码，密码，用户名或者手机号 区分用户名或者手机号的num，1为手机号注册，2为用户名注册*/
                        let result=await verificationPwd(this.ruleFormPwd.pwd2,this.ruleFormPwd.pwd1,userName,phone,type);
                        if(result.status){
                            console.log(result.data);
                            cookies.set('userInfo',result.data.token);
                            console.log(cookies.get('userInfo'));
                            setStore('userId',result.data.id);
                            /*注意此位置*/
                            // this.$router.push('/studentAndTeacherPlatform/schoolManagement')
                            this.$emit('nextStep',{title:zhi,active:3})
                        }
                    }else{
                        return false;
                    }
                })

            },
            preStep(){
                console.log('触发了吗');
                this.$emit('nextStep',{title:'',active:1})
            }
        }
    }
</script>

<style scoped>

</style>
